import { Box, ColorSwatchGroup, Typography } from '@customink/pigment-react';
import {
  type Product,
  useProduct,
} from '@customink/project-service-react-components';

import { HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY } from '@/constants';
import { useEditDesignLink } from '@/hooks/Design';

type AlternativeStyleProps = {
  product: Product;
  designCid?: string;
};

export default function AlternativeStyle({
  product,
  designCid,
}: AlternativeStyleProps) {
  const handleEditDesign = useEditDesignLink(designCid);
  const { data: altProduct } = useProduct({
    colorId: product.singles_alternative_id,
  });

  if (!altProduct?.swatches) {
    return null;
  }

  const swatches = altProduct.swatches
    .filter((s) => s.dtgEnabled)
    .map((s) => ({
      color: s.hex,
      value: s.colorId, // pigment type is too strict to just let this be called colorId
    }));

  // Pigment doesn't export this type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelect = (swatch: any) => {
    handleEditDesign({
      PK: String(swatch.value),
    });
  };

  return (
    <>
      <Typography data-testid="min-qty-high-color-alt-style">
        Please either:
      </Typography>
      <ul style={{ margin: 0 }}>
        <li>
          <Typography>
            Increase the order quantity to{' '}
            {HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY} or more, or
          </Typography>
        </li>
        <li>
          <Typography>
            Try the {altProduct?.name} in one of these colors, available at any
            quantity. You can review your selection in the Design Lab.
          </Typography>
        </li>
      </ul>
      <Box sx={{ padding: 1 }}>
        <ColorSwatchGroup
          defaultSelected={false}
          onSwatchSelect={onSelect}
          swatchData={swatches}
        />
      </Box>
    </>
  );
}
